import { render, staticRenderFns } from "./ApplyPasswordResetDone.vue?vue&type=template&id=5dea71bd&scoped=true&lang=pug"
import script from "./ApplyPasswordResetDone.vue?vue&type=script&lang=js"
export * from "./ApplyPasswordResetDone.vue?vue&type=script&lang=js"
import style0 from "./ApplyPasswordResetDone.vue?vue&type=style&index=0&id=5dea71bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dea71bd",
  null
  
)

export default component.exports